import { Alert, Loader, Modal, Table, Text } from "@mantine/core";
import { useSlideTissueRows } from "../../hooks/useSlideInsufficientTissue";
import { SlideInsufficientTissueCheckbox } from "./SlideInsufficientTissueCheckbox";

interface Props {
  caseId: string;
  onClose: () => void;
}

export function SlideInsufficientTissueModal({ caseId, onClose }: Props) {
  const { data, isLoading, isError } = useSlideTissueRows("scanner", caseId);
  return (
    <Modal
      opened
      onClose={onClose}
      title="Insufficient tissue"
      centered
      size="lg"
      withinPortal
    >
      {isLoading && <Loader size="sm" />}
      {isError && (
        <Alert color="red" variant="light" title="Could not load slides">
          Reopen the case to try again.
        </Alert>
      )}
      {data && (
        <Table striped withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Slide name</Table.Th>
              <Table.Th>Insufficient tissue</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {data.map((slide) => (
              <Table.Tr key={slide.id}>
                <Table.Td>{slide.name}</Table.Td>
                <Table.Td>
                  <SlideInsufficientTissueCheckbox
                    caseId={caseId}
                    slideId={slide.id}
                    name={slide.name}
                    source="scanner"
                  />
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
      {data?.length === 0 && (
        <Text c="dimmed">No slides found for this case.</Text>
      )}
    </Modal>
  );
}
